// extracted by mini-css-extract-plugin
module.exports = {"Error":"styles_Error__2nFJD"};